"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _isNullOrUndefined = _interopRequireDefault(require("./isNullOrUndefined"));
var DATE_TYPE_FORMAT_MAP = {
  DATE: 'DD-MM-YYYY',
  DATETIME: 'DD-MM-YYYY HH:mm:ss',
  JSONDATE: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
  TIMESTAMP: 'DD-MM-YYYY HH:mm:ss',
  TIME: 'HH:mm:ss',
  MOMENT: 'DD/MM/YYYY'
};
var getDefaultFormatByType = function getDefaultFormatByType(type) {
  return DATE_TYPE_FORMAT_MAP[type.toUpperCase()];
};
var parseMomentByColumnType = function parseMomentByColumnType(column, date) {
  var type = column.type,
    format = column.format;
  var defaultFormatByType = getDefaultFormatByType(type);
  if ((0, _isNullOrUndefined.default)(format)) return (0, _moment.default)(date, defaultFormatByType);
  return (0, _moment.default)((0, _moment.default)(date, defaultFormatByType).format(format), format);
};
var _default = exports.default = {
  parseMomentByColumnType: parseMomentByColumnType,
  DATE_TYPE_FORMAT_MAP: DATE_TYPE_FORMAT_MAP
};